import { render } from "./WithdrawnRequests.vue?vue&type=template&id=53881340"
import script from "./WithdrawnRequests.vue?vue&type=script&lang=js"
export * from "./WithdrawnRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__